import { render, staticRenderFns } from "./historyKnowledge.vue?vue&type=template&id=2bc76e4a&scoped=true&"
import script from "./historyKnowledge.vue?vue&type=script&lang=js&"
export * from "./historyKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./historyKnowledge.vue?vue&type=style&index=0&id=2bc76e4a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc76e4a",
  null
  
)

export default component.exports